
import { defineComponent } from 'vue'
// Amplitude
import { amplitudeLogEvent, amplitudeEvents } from '@shared/lib'
export default defineComponent({
  name: 'OrderList',
  mounted () {
    setTimeout(() => {
      amplitudeLogEvent(amplitudeEvents.ORDER, { ОтображениеЗаказа: 'Есть заказ' })
    }, 3000)
  }
})
